import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Input,
  FormGroup,
  Button,
  Label,
  CardHeader,
  CardFooter,
} from "reactstrap";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import NotificationAlert from "react-notification-alert";
import {
  BASE_URL_CHAT_WHATSAPP,
  SMS_TMPLTS_SNDRIDS,
  WHATSAPP_INSTANT,
  WHATSAPP_TEMPLATE,
  WHATSAPP_EMBED_TEMPLATE,
} from "../../constants";
import axios from "axios";
import apiService from "../../variables/apiService";
import "../../assets/scss/style.scss";
import catlogImg from "../../assets/img/catlog.gif";
import mcustomImg from "../../assets/img/mcustom.png";
import mflowsImg from "../../assets/img/mflows.gif";
import callImg from "../../assets/img/callrequest.gif";
import ucustomImg from "../../assets/img/ucustom.png";
import uflowsImg from "../../assets/img/uflows.gif";
import authImg from "../../assets/img/auth.png";
import wtsapImg from "../../assets/img/wtsapbckgrnd.png";

let initialcategory = "Custom";

const languages = [
  { label: "English", value: "english" },
  { label: "Hindi", value: "hindi" },
];
const headres = [
  { label: "None", value: "none" },
  { label: "Text", value: "text" },
  { label: "Image", value: "image" },
  { label: "Video", value: "video" },
  { label: "Document", value: "document" },
];
const btns = [
  { label: "Quick reply buttons", value: "QUICK_REPLY" },
  { label: "Call Phone Number", value: "phone_number" },
  { label: "Copy offer code", value: "COPY_OFFER_CODE" },
  { label: "Visit website", value: "url" },
];

const initialTemp = {
  tempname: "",
  language: { label: "English", value: "english" },
  variable: "",
  header: { label: "None", value: "none" },
  headerContent: { type: "", value: "" },
  body: "Hello",
  footer: "",
  button: [],
};

const Viewtemplates = (props) => {
  const resp = props?.location?.state?.data;
  const notificationAlertRef = React.useRef(null);
  const [option, setoption] = useState("setup");
  const [temptype, settemptype] = useState("Marketing");
  const [tempcategory, settempcategory] = useState(initialcategory);
  const [buttonUi, setbuttonUi] = useState([]);
  const [dynamicvalueUI, setdynamicvalueUI] = useState([]);

  const [temp, settemp] = useState({
    tempname: resp?.name,
    language: { label: "English", value: "english" },
    variable: "",
    header: { label: "None", value: "none" },
    headerContent: { type: "", value: "" },
    body: "Hello",
    footer: "",
    button: [],
  });

  const [error, seterror] = useState({
    name: "",
  });

  const textareaRef = useRef(null);

 console.log(resp,"form ");




  const addbody = (name) => {
    const textarea = textareaRef.current;
    const { selectionStart } = textarea;

    let newBody = "";
    if (name === "bold") {
      newBody = temp.body.slice(0, selectionStart) + "**";
    } else if (name === "italic") {
      newBody = temp.body.slice(0, selectionStart) + "__";
    } else if (name === "variable") {
      let matches = temp?.body?.match(/{{.*?}}/g); // non-greedy match
      let count = matches ? matches.length : 0;
      newBody = temp.body.slice(0, selectionStart) + `{{${++count}}}`;
    }

    settemp((prev) => ({ ...prev, body: newBody }));
  };

  const uploadImg = (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {
        let imgUrl = response?.data?.Response;
        settemp((prev) => ({
          ...prev,
          headerContent: {
            ...prev.headerContent,
            type: "image",
            value: imgUrl,
          },
        }));
      })
      .catch((err) => console.log("err==>", err));
  };

  const createbtn = (val, i, type) => {
    if (type == "remove") {
      const a = buttonUi.filter((item, index) => index != i);

      setbuttonUi(a);
    } else {
      if (val?.value === "url") {
        setbuttonUi((pre) => [...pre, { type: val?.value, text: "", url: "" }]);
      } else {
        setbuttonUi((pre) => [
          ...pre,
          { type: val?.value, text: "", [val?.value]: "" },
        ]);
      }
    }
  };

  // Dynamic Variable
  const createdynamicbtn = (i, type) => {
    if (type == "remove") {
      const a = dynamicvalueUI.filter((item, index) => index != i);

      setdynamicvalueUI(a);
    } else {
      setdynamicvalueUI((pre) => [...pre, { type: "text", text: "" }]);
    }
  };

  const btntxt = (type, index, val) => {
    setbuttonUi((prev) =>
      prev?.map((item, i) => {
        if (i == index && item.type == type) {
          return { ...item, text: val };
        }
        return item;
      })
    );
  };
  const btnvalue = (type, index, val) => {
    setbuttonUi((prev) =>
      prev?.map((item, i) => {
        if (i == index && item.type == type) {
          if (type === "url") {
            return { ...item, url: val };
          } else {
            return { ...item, [type]: val };
          }
        }
        return item;
      })
    );
  };

  const dynamicbtnvalue = (index, val) => {
    setdynamicvalueUI((prev) =>
      prev?.map((item, i) => {
        if (i == index) {
          return { ...item, type: "text", text: val };
        }
        return item;
      })
    );
  };

  return (
    <div className="content">
      <Card style={{ backgroundColor: "#e3e1e1" }}>
        <CardBody>
          <NotificationAlert ref={notificationAlertRef} />
          <b>Manage Templates</b>
          <Row>
            <Col md="7" sm="12">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 15,
                }}
              >
                <FormGroup
                  style={{
                    backgroundColor: option === "setup" ? "#03a9f421" : "white",

                    borderRadius: 5,
                  }}
                  check
                  className="form-check-radio template-radio"
                  inline
                >
                  <Label style={{ paddingRight: "20px" }}>
                    <Input
                      id="exampleRadios3"
                      name="exampleRadio"
                      type="radio"
                      value={option}
                      checked={option === "setup" ? true : false}
                      onClick={(e) => setoption("setup")}
                    />
                    <span className="form-check-sign temp" />
                    Set up template
                  </Label>
                </FormGroup>
                <FormGroup
                  check
                  className="form-check-radio template-radio"
                  inline
                  style={{
                    backgroundColor: option === "edit" ? "#03a9f421" : "white",

                    borderRadius: 5,
                  }}
                >
                  <Label style={{ paddingRight: "20px" }}>
                    <Input
                      id="exampleRadios3"
                      name="exampleRadio"
                      type="radio"
                      value={option}
                      checked={option === "edit" ? true : false}
                      onClick={(e) => {
                        setoption("edit");
                      }}
                    />
                    <span className="form-check-sign temp " />
                    Edit template
                  </Label>
                </FormGroup>
              </div>

              {/* Setup Template */}
              {option === "setup" && (
                <>
                  <div style={{ margin: "10px" }}>
                    <h6>Set up your template</h6>

                    <p>
                      Choose the category that best describes your message
                      template. Then, select the type of message that you want
                      to send. Learn more about categories.
                    </p>
                  </div>
                  <div>
                    <Row
                      style={{
                        border: "1px solid grey",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        textAlign: "center",
                        marginLeft: "10px",
                        height: "37px",
                      }}
                    >
                      <Col
                        md="4"
                        sm="12"
                        style={{
                          background:
                            temptype === "Marketing" ? "#c0c7cb" : "white",
                          padding: 5,
                        }}
                        onClick={() => {
                          settemptype("Marketing");
                          settempcategory(initialcategory);
                        }}
                      >
                        Marketing
                      </Col>
                      <Col
                        md="4"
                        sm="12"
                        style={{
                          background:
                            temptype === "utility" ? "#c0c7cb" : "white",
                          padding: 5,
                          borderLeft: "1px solid grey",
                        }}
                        onClick={() => {
                          settemptype("utility");
                          settempcategory(initialcategory);
                        }}
                      >
                        Utility
                      </Col>
                      <Col
                        md="4"
                        sm="12"
                        style={{
                          background:
                            temptype === "Authentication" ? "#c0c7cb" : "white",
                          padding: 5,
                          borderLeft: "1px solid grey",
                        }}
                        onClick={() => {
                          settemptype("Authentication");
                          settempcategory("otp");
                        }}
                      >
                        Authentication
                      </Col>
                    </Row>
                    {/* Template Category */}
                    <Row>
                      {(temptype === "Marketing" || temptype === "utility") && (
                        <div
                          style={{
                            background:
                              tempcategory === "Custom" ? "#c0c7cb" : "white",
                            marginTop: 10,
                            borderRadius: 5,
                            marginLeft: 10,
                          }}
                          onClick={(e) => settempcategory("Custom")}
                        >
                          <FormGroup
                            check
                            className="form-check-radio template-radio"
                            inline
                          >
                            <Label>
                              <Input
                                id="mrktrdio1"
                                name="mrktrdio"
                                type="radio"
                                value={tempcategory}
                                checked={
                                  tempcategory == "Custom" ? true : false
                                }
                                onClick={(e) => settempcategory("Custom")}
                              />
                              <span className="form-check-sign temp" />
                              Custom
                            </Label>
                          </FormGroup>
                          <p className="template-radio-p">
                            Send promotions or announcements to increase
                            awareness and engagement.
                          </p>
                        </div>
                      )}
                      {temptype === "Marketing" && (
                        <div
                          style={{
                            background:
                              tempcategory === "catalogue"
                                ? "#c0c7cb"
                                : "white",
                            borderRadius: 5,
                            marginLeft: 10,
                          }}
                          onClick={(e) => settempcategory("catalogue")}
                        >
                          <FormGroup
                            check
                            className="form-check-radio template-radio"
                            inline
                          >
                            <Label>
                              <Input
                                id="mrktrdio2"
                                name="mrktrdio1"
                                type="radio"
                                value={tempcategory}
                                checked={
                                  tempcategory == "catalogue" ? true : false
                                }
                                onClick={(e) => settempcategory("catalogue")}
                              />
                              <span className="form-check-sign temp" />
                              Catalogue
                            </Label>
                          </FormGroup>
                          <p className="template-radio-p">
                            Send messages about your entire catalogue or
                            multiple products from it.
                          </p>
                        </div>
                      )}
                      {(temptype === "Marketing" || temptype === "utility") && (
                        <div
                          style={{
                            background:
                              tempcategory === "Flows" ? "#c0c7cb" : "white",
                            borderRadius: 5,
                            marginLeft: 10,
                          }}
                          onClick={(e) => settempcategory("Flows")}
                        >
                          <FormGroup
                            check
                            className="form-check-radio template-radio"
                            inline
                          >
                            <Label>
                              <Input
                                id="mrktrdio3"
                                name="mrktrdio1"
                                type="radio"
                                value="div1"
                                checked={tempcategory == "Flows" ? true : false}
                                onClick={(e) => settempcategory("Flows")}
                              />
                              <span className="form-check-sign temp" />
                              Flows
                            </Label>
                          </FormGroup>
                          <p className="template-radio-p">
                            Send a form to capture customer interests,
                            appointment requests or run surveys.
                          </p>
                        </div>
                      )}
                      {(temptype === "Marketing" || temptype === "utility") && (
                        <div
                          style={{
                            background:
                              tempcategory === "Calling permissions request"
                                ? "#c0c7cb"
                                : "white",
                            borderRadius: 5,
                            marginLeft: 10,
                          }}
                          onClick={(e) =>
                            settempcategory("Calling permissions request")
                          }
                        >
                          <FormGroup
                            check
                            className="form-check-radio template-radio"
                            inline
                          >
                            <Label>
                              <Input
                                id="mrktrdio4"
                                name="mrktrdio1"
                                type="radio"
                                value="div1"
                                checked={
                                  tempcategory == "Calling permissions request"
                                    ? true
                                    : false
                                }
                                onClick={(e) =>
                                  settempcategory("Calling permissions request")
                                }
                              />
                              <span className="form-check-sign temp" />
                              Calling permissions request
                            </Label>
                          </FormGroup>
                          <p className="template-radio-p">
                            Ask customers if you can Calling permissions request
                            them on WhatsApp
                          </p>
                        </div>
                      )}

                      {temptype === "Authentication" && (
                        <div
                          style={{
                            background:
                              tempcategory === "otp" ? "#c0c7cb" : "white",
                            marginTop: 10,
                            borderRadius: 5,
                            marginLeft: 10,
                          }}
                        >
                          <FormGroup
                            check
                            className="form-check-radio template-radio"
                            inline
                          >
                            <Label>
                              <Input
                                id="mrktrdio4"
                                name="mrktrdio1"
                                type="radio"
                                value="div1"
                                checked={true}
                              />
                              <span className="form-check-sign temp" />
                              One-time passcode
                            </Label>
                          </FormGroup>
                          <p className="template-radio-p">
                            Send codes to verify a transaction or login.
                          </p>
                        </div>
                      )}
                    </Row>
                  </div>
                </>
              )}
              {/* Setup Template */}

              {/* Edit Template Start */}
              {option === "edit" && (
                <div>
                  <Row>
                    <Col>
                      <Card style={{ backgroundColor: "white" }}>
                        <CardBody>
                          <p>
                            <b>
                              {!temp?.tempname
                                ? "your_template_name"
                                : temp?.tempname}
                              .{temp?.language?.label}
                            </b>
                          </p>
                          <span>
                            {temptype} . {tempcategory}
                          </span>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Card style={{ backgroundColor: "white" }}>
                        <CardBody>
                          <b>Template name and language</b>
                          <Row>
                            <Col md="8">
                              <p>Name your template</p>
                              <FormGroup>
                                <Input
                                  type="text"
                                  placeholder="Enter a template name"
                                  value={temp?.tempname}
                                  name="tname"
                               
                                />
                              </FormGroup>
                              <span style={{ float: "right" }}>
                                {temp?.tempname?.length}/512
                              </span>
                            </Col>
                            <Col md="4">
                              <p>Select language</p>
                              <Select
                                className="react-select info"
                                classNamePrefix="react-select"
                                name="templateSelect"
                                value={temp.language}
                                onChange={(value) =>
                                  settemp({ ...temp, language: value })
                                }
                                options={languages}
                                placeholder="Select"
                              />
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Card style={{ backgroundColor: "white" }}>
                        <CardBody>
                          <p>
                            <b>Content</b>
                          </p>
                          <p>
                            Fill in the header, body and footer sections of your
                            template.
                          </p>
                          <Row>
                            <Col md="12">
                              <p>
                                <b>Variable</b>{" "}
                              </p>
                              <Select
                                className="react-select info"
                                classNamePrefix="react-select"
                                name="templateSelect"
                                value={temp.variable}
                                onChange={(value) =>
                                  settemp({ ...temp, variable: value })
                                }
                                options={[
                                  { label: "Name", value: "name" },
                                  { label: "Number", value: "number" },
                                ]}
                                placeholder="Select"
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <p>
                                <b>Header</b>{" "}
                              </p>
                              <Select
                                className="react-select info"
                                classNamePrefix="react-select"
                                name="templateSelect"
                                value={temp?.header}
                                onChange={(value) =>
                                  settemp({ ...temp, header: value })
                                }
                                options={headres}
                                placeholder="Select"
                              />
                            </Col>
                          </Row>

                          {temp?.header?.value != "text" &&
                            temp?.header?.value != "none" && (
                              <Row>
                                <Col md="12">
                                  <input
                                    type="file"
                                    id="file"
                                    accept=".xlsx,.xls,image/png,image/jpeg,.doc, .docx,.ppt, .pptx,.txt,.pdf,.mp4"
                                    onChange={(e) => {
                                      // setImg(e.target.files[0]);
                                      uploadImg(e.target.files[0]);
                                    }}
                                  />
                                </Col>
                              </Row>
                            )}
                          <Row>
                            <Col md="12">
                              <p>
                                <b>Body</b>{" "}
                              </p>
                              <Input
                                style={{
                                  padding: "5px",
                                  resize: "auto",
                                  maxHeight: "none",
                                }}
                                type="textarea"
                                name="message"
                                ref={textareaRef}
                                value={temp.body}
                                onChange={(e) =>
                                  settemp({ ...temp, body: e.target.value })
                                }
                              />
                              <div style={{ float: "right" }}>
                                <span
                                  style={{ marginRight: "10px" }}
                                  onClick={() => addbody("bold")}
                                >
                                  <i>B</i>
                                </span>
                                <span
                                  style={{ marginRight: "10px" }}
                                  onClick={() => addbody("italic")}
                                >
                                  <i>I</i>
                                </span>
                                <span
                                  onClick={(value) => {
                                    addbody("variable");
                                    createdynamicbtn(0, "add");
                                  }}
                                >
                                  <b>+ Add variable</b>
                                </span>
                              </div>
                            </Col>
                            <Row className="mt-4">
                              {dynamicvalueUI?.map((item, index) => {
                                return (
                                  <Row>
                                    {index === 0 && <p>Body</p>}
                                    <Col md="5">
                                      <FormGroup>
                                        <Input
                                          type="text"
                                          placeholder="enter text"
                                          value={`{{${index + 1}}}`}
                                          name="btntxt"
                                          disabled={true}
                                        />
                                      </FormGroup>
                                    </Col>

                                    <Col md="5">
                                      <FormGroup>
                                        <Input
                                          type="text"
                                          placeholder={`Enter content for {{${
                                            index + 1
                                          }}}`}
                                          value={buttonUi[index]?.url}
                                          name="btntxt"
                                          onChange={(e) =>
                                            dynamicbtnvalue(
                                              index,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </FormGroup>
                                    </Col>

                                    <Col md="2" style={{ cursor: "pointer" }}>
                                      <span
                                        onClick={() =>
                                          createdynamicbtn(index, "remove")
                                        }
                                      >
                                        Remove
                                      </span>
                                    </Col>
                                  </Row>
                                );
                              })}

                              <Col md="8"></Col>
                            </Row>
                          </Row>
                          <Row></Row>
                          <Row>
                            <Col md="12">
                              <label>Footer</label>
                              <FormGroup>
                                <Input
                                  type="text"
                                  placeholder="Enter text"
                                  value={temp.footer}
                                  name="tname"
                                  onChange={(e) =>
                                    settemp({ ...temp, footer: e.target.value })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Card style={{ backgroundColor: "white" }}>
                        <CardBody>
                          <p>
                            <b>Buttons• </b> Optional
                          </p>
                          <p>
                            Create buttons that let customers respond to your
                            message or take action. You can add up to ten
                            buttons. If you add more than three buttons, they
                            will appear in a list.
                          </p>
                          <Row>
                            <Col md="6">
                              <Select
                                className="react-select info"
                                classNamePrefix="react-select"
                                name="templateSelect"
                                // value={temp?.button}
                                onChange={(value) => createbtn(value, 0, "add")}
                                options={btns}
                                placeholder="Add Button"
                              />
                            </Col>
                            <Col></Col>
                          </Row>
                          <Row className="mt-4">
                            {buttonUi?.map((item, index) => {
                              return (
                                <Row style={{ marginBottom: 20 }}>
                                  <span>{item.type}</span>
                                  <Col md="5">
                                    <FormGroup>
                                      <p>Button Text</p>
                                      <Input
                                        type="text"
                                        placeholder="enter text"
                                        value={buttonUi[index]?.text}
                                        name="btntxt"
                                        onChange={(e) =>
                                          btntxt(
                                            item.type,
                                            index,
                                            e.target.value
                                          )
                                        }
                                      />
                                    </FormGroup>
                                  </Col>

                                  {item.type === "url" &&
                                    item.type != "QUICK_REPLY" && (
                                      <Col md="5">
                                        <FormGroup>
                                          <p>Website URL</p>
                                          <Input
                                            type="text"
                                            placeholder="enter text"
                                            value={buttonUi[index]?.url}
                                            name="btntxt"
                                            onChange={(e) =>
                                              btnvalue(
                                                item.type,
                                                index,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                    )}
                                  {item.type !== "url" &&
                                    item.type != "QUICK_REPLY" && (
                                      <Col md="5">
                                        <FormGroup>
                                          {item.type == "COPY_OFFER_CODE" ? (
                                            <p>Offer code</p>
                                          ) : (
                                            <p>Phone Number</p>
                                          )}
                                          <Input
                                            type="text"
                                            placeholder="enter text"
                                            value={buttonUi[index]?.payload}
                                            name="btntxt"
                                            onChange={(e) =>
                                              btnvalue(
                                                item.type,
                                                index,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                    )}

                                  <Col md="2" style={{ cursor: "pointer" }}>
                                    <span
                                      onClick={() =>
                                        createbtn("", index, "remove")
                                      }
                                    >
                                      Remove
                                    </span>
                                  </Col>
                                </Row>
                              );
                            })}

                            <Col md="8"></Col>
                          </Row>

                          <Row></Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}

              {/* Edit Template End */}
              <div></div>
            </Col>
            <Col md="1" sm="12"></Col>
            <Col md="4" sm="12">
              <Card
                style={{
                  marginBottom: "15px",
                  marginTop: "15px",
                }}
              >
                <CardHeader style={{ backgroundColor: "#d5d4d4" }}>
                  <b>Template Preview</b>
                </CardHeader>
                {option === "setup" && (
                  <CardBody style={{ backgroundColor: "#d5d4d4" }}>
                    {tempcategory === "Custom" && temptype === "Marketing" && (
                      <img src={mcustomImg} />
                    )}
                    {tempcategory === "catalogue" && <img src={catlogImg} />}

                    {tempcategory === "Flows" && temptype === "Marketing" && (
                      <img src={mflowsImg} />
                    )}
                    {tempcategory === "Flows" && temptype === "utility" && (
                      <img src={uflowsImg} />
                    )}
                    {tempcategory === "Calling permissions request" && (
                      <img src={callImg} />
                    )}
                    {tempcategory === "Custom" && temptype === "utility" && (
                      <img src={ucustomImg} />
                    )}
                    {temptype === "Authentication" && <img src={authImg} />}
                  </CardBody>
                )}
                {option === "edit" && (
                  <CardBody style={{ backgroundColor: "#d5d4d4" }}>
                    <div
                      style={{
                        width: "auto",
                        backgroundColor: "white",
                        minHeight: "20%",
                        minWidth: "20%",
                        borderBottomRightRadius: 10,
                        borderTopRightRadius: 10,
                        borderBottomLeftRadius: 10,
                        height: "auto",
                        width: "200px",
                      }}
                    >
                      {temp?.header?.value == "image" && (
                        <div>
                          <img
                            src={temp?.headerContent?.value}
                            style={{
                              height: "auto",
                              width: "200px",
                              backgroundColor: "white",
                            }}
                          />
                        </div>
                      )}
                      {temp?.header?.value == "video" && (
                        <div>
                          {/* https://whatsappui.netxcell.com:8373/files/4114797-uhd_3840_2160_25fps.mp4 */}

                          <video
                            width="280"
                            controls
                            onPlay={() => console.log("Video started")}
                            onPause={() => console.log("Video paused")}
                          >
                            <source
                              src={temp?.headerContent?.value}
                              type="video/mp4"
                            />
                          </video>
                        </div>
                      )}
                      <p style={{ color: "black", padding: 10 }}>
                        {temp?.body}
                      </p>
                      {
                        temp.footer.length>0&&
                        <div> <p style={{ color: "grey", padding: 10 }}>{temp.footer}</p></div>
                      }
                      
                      <div style={{ textAlign: "center" }}>
                        {buttonUi?.map((item, index) => {
                          return (
                            <p
                              style={{
                                borderTop: "1px solid #e1dddd",
                                padding: 10,
                                color: "blue",
                              }}
                            >
                              {" "}
                              {item.text || "Button Text"}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </CardBody>
        <CardFooter>
          <Card>
            <CardFooter>
              <Row>
                {option === "setup" ? (
                  <Col md="10" sm="12"></Col>
                ) : (
                  <>
                    <Col md="2" sm="12">
                      <Button
                        color="primary "
                        className="mt-4 btn "
                        id="tooltipsubmit"
                        type="button"
                        onClick={() => setoption("setup")}
                      >
                        Previous
                      </Button>
                    </Col>
                    <Col md="8" sm="12"></Col>
                  </>
                )}
                {option === "setup" ? (
                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn "
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => setoption("edit")}
                    >
                      Next
                    </Button>
                  </Col>
                ) : (
                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn "
                      id="tooltipsubmit"
                      type="button"
                      
                    >
                      Submit
                    </Button>
                  </Col>
                )}
              </Row>
            </CardFooter>
          </Card>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Viewtemplates;
